import React from "react";
import moment from "moment"

import PendingIcon from '../../../../images/stopwatch.png';
import ErrorIcon from '../../../../images/stopwatch.png';
import TimesUpIcon from '../../../../images/icons/times-up.png';
import SuccessIcon from '../../../../images/icons/success.png';

export const PendingMessage = props => (
  <div className="payment-result-message-wrapper">
    {
      !props.hasConfirm ?
        <p>Next step, complete and process your order by clicking this button.</p>
        : null
    }
    <p>Please complete your payment before <strong>{moment(props.expire).format('dddd, LL HH:mm')}</strong>.</p>
  </div>
)

export const VerifiedPaymentMessage = props => (
  <div className="payment-result-message-wrapper">
    <p>Holding on, your order is being processed by Admin. Please wait until Admin confirm your payment. ETA (1x24 hour).</p>
  </div>
)

export const ExpiredMessage = () => (
  <div className="payment-result-message-wrapper">
    <p><strong>Oops, </strong>your order has been expired. You cannot confirm your payment. Try to re-order again!</p>
    <p>If you have any questions about your order, please contact our team by email to <a href="mailto:info@kickavenue.com" title="Mail to info@kickavenue.com">info@kickavenue.com</a>. Please put your invoice number into your subject email.</p>
  </div>
)

export const ErrorMessage = ({ error }) => (
  <div className="payment-result-message-wrapper">
    <p><strong>Oops, </strong>we got unhandled issues when try processing your payment.</p>
    <p>Or if you have any questions about your order, please contact our team by email to <a href="mailto:info@kickavenue.com" title="Mail to info@kickavenue.com">info@kickavenue.com</a>. Please put your invoice number into your subject email.</p>
  </div>
)

export const CancelledMessage = () => (
  <div className="payment-result-message-wrapper">
    <p><strong>Oops, </strong>your order has been cancelled. Try to re-order again!</p>
    <p>If you have any questions about your order, please contact our team by email to <a href="mailto:info@kickavenue.com" title="Mail to info@kickavenue.com">info@kickavenue.com</a>. Please put your invoice number into your subject email.</p>
  </div>
)

export const SucceededMessage = () => (
  <div className="payment-result-message-wrapper">
    <p>Thank you for completing your payment. Your order will be process.</p>
    <p>If you have any questions about your order, please contact our team by email to <a href="mailto:info@kickavenue.com" title="Mail to info@kickavenue.com">info@kickavenue.com</a>. Please put your invoice number into your subject email.</p>
  </div>
)

export const renderMessage = (status, isExpired, error, paymentStep, expiry) => {
  switch (status) {
    case 'PENDING':
    case 'VERIFYING_BID': return isExpired ? <ExpiredMessage /> : <PendingMessage hasConfirm={paymentStep === 2} expire={expiry} />;
    case 'VERIFYING_PAYMENT': return <VerifiedPaymentMessage />;
    case 'EXPIRED': return <ExpiredMessage />;
    case 'COMPLETED': return <SucceededMessage />;
    case 'REJECTED':
    case 'PENDING_REFUND':
    case 'REFUNDED':
    case 'CANCELLED': return <CancelledMessage />;
    default: return <ErrorMessage error={error} />;
  }
}

export const getHeaderText = (paymentStatus, isExpired) => {
  switch (paymentStatus) {
    case 'PENDING':
    case 'VERIFYING_BID': return isExpired ? 'Your payment has been expired.' : 'Waiting your payment confirmation.';
    case 'VERIFYING_PAYMENT': return 'Your payment is being processed by Admin.';
    case 'EXPIRED': return 'Your payment has been expired.';
    case 'COMPLETED': return 'Hooray! You have successfully purchased!';
    case 'REJECTED':
    case 'PENDING_REFUND':
    case 'REFUNDED':
    case 'CANCELLED': return 'Your payment has been cancelled.';
    default: return 'We got something issues when processing your payment.';
  }
}

export const getStatusIcon = (paymentStatus, isExpired) => {
  switch (paymentStatus) {
    case 'PENDING':
    case 'VERIFYING_BID': return isExpired ? TimesUpIcon : PendingIcon;
    case 'VERIFYING_PAYMENT': return PendingIcon;
    case 'EXPIRED': return TimesUpIcon;
    case 'COMPLETED': return SuccessIcon;
    default: return ErrorIcon;
  }
}

export const getSelectedPayment = (paymentMethod, bankCode) => {
  switch (paymentMethod) {
    case 'virtual_account': return bankCode ? `${bankCode} - Virtual Account` : 'Virtual Account';
    case 'credit_card': return 'Credit Card';
    case 'kredivo': return 'Kredivo';
    case 'akulaku': return 'Akulaku';
    case 'atome': return 'Atome';
    case 'full_wallet': return 'Kick Credit';
    case 'gopay': return 'Gopay';
    default: return 'Bank Transfer';
  }
}